/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEqual = createReactComponent("outline", "equal", "IconEqual", [["path", { "d": "M5 10h14", "key": "svg-0" }], ["path", { "d": "M5 14h14", "key": "svg-1" }]]);

export { IconEqual as default };
//# sourceMappingURL=IconEqual.mjs.map
